import { mapGetters, mapMutations, mapState } from 'vuex'
import _startCase from 'lodash/startCase'

export default {
    watch: {
        userType: function(value) {
            this.setField({ name: 'fiscalId', value: this.fiscalId })
            this.setField({ name: 'companyName', value: this.companyName })
        },

        phone: function(value) {
            this.phone = value.replace(/ /g, "")
        },

        showStepErrors: function(show) {
            if(show) {
                this.setError({ name: 'fiscalId', value: !this.valid.fiscalId})
                this.setError({ name: 'name', value: !this.valid.name})
                this.setError({ name: 'cups', value: !this.valid.cups})
                this.setError({ name: 'surname1', value: !this.valid.surname1})
                this.setError({ name: 'email', value: !this.valid.email})
                this.setError({ name: 'phone', value: !this.valid.phone})
                this.setError({ name: 'companyName', value: !this.valid.companyName})
                this.setError({ name: 'addressMunicipality', value: !this.valid.addressMunicipality})
                this.setError({ name: 'addressPostalCode', value: !this.valid.addressPostalCode})
                this.setError({ name: 'addressStreet', value: !this.valid.addressStreet})
                this.setError({ name: 'addressNumber', value: !this.valid.addressNumber})
                this.setError({ name: 'iban', value: !this.valid.iban})
                this.setError({ name: 'order_comments', value: !this.valid.order_comments})
                this.setError({ name: 'fiscalIdAttorney', value: !this.valid.fiscalIdAttorney})
                this.setError({ name: 'terms', value: !this.valid.terms})
                this.setError({ name: 'recaptcha', value: !this.valid.recaptcha})
            } else {
                this.clearErrors()
            }
        },

        productNetIsSelected: function(value) {
            this.copyNetAddress = value
            this.autoFill()
        },

        copyNetAddress: function(checked) {
            if(checked) this.autoFill()
        },

        netAddressProvince: function(data) {
            this.autoFill()
        },
        netAddressMunicipality: function(data) {
            this.autoFill()
        },
        netAddressStreet: function(data) {
            this.autoFill()
        },
        netAddressNumber: function(data) {
            this.autoFill()
        },
        iban: async function (data) {
            if (this.valid.iban && data) {
                try {
                    let response = await axios.get('/orders/iban', {params: {iban: data}})
                    if (response.data.valid) {
                        this.bank = _startCase(response.data?.bank?.bank?.name.toLowerCase() ?? null)
                    }else {
                        this.bank = null
                        this.setError({name: 'iban', value: true})
                        this.setValid({name: 'iban', value: false})
                    }
                }catch (error) {
                    console.error(error)
                }

            }else {
                this.bank = null
            }
        },

    },

    data() {
        return {
            copyNetAddress: false,
            bank: null,
            cups: '0'
        }
    },

    mounted() {
        /* ------------------------------
         * Uncomment for development
         * ------------------------------
        */
        // this.userType = 'company'
        // // this.fiscalId = '58768898B'
        // this.fiscalDoc = 'cif'
        // this.fiscalId = 'U99313108'
        // this.name = 'Josep Maria'
        // this.companyName = 'Llonganisses S.A.'
        // this.surname1 = 'Puigcorvé'
        // this.surname2 = 'Blancafort'
        // this.email = 'josep.maria@puigcorve.cat'
        // this.phone = '654321234'
        // this.addressMunicipality = 'Sant Esteve de les Roures'
        // this.addressPostalCode = '08999'
        // this.addressStreet = 'Carrer del nom mot llarg'
        // this.addressNumber = '123-A'
        // this.addressFloor = '3r'
        // this.addressDoor = '2a'
        // this.iban = 'ES6701826755424696332239'
        // this.fiscalIdAttorney = '12345678Z'


        // auto fill collaborator_code
        this.collaborator_code = webStorage.store('orders').get('collaborator_code')

    },

    methods: {
        resetFiscalDoc() {
            this.fiscalDoc = this.userType === 'company' ? "cif" : "dni"
        },

        sortSurnames() {
            if(this.surname2 && !this.surname1){
              this.surname1 = this.surname2
              this.surname2 = null
            }
        },

        autoFill() {
            this.addressProvince = this.netAddressProvince
            this.addressMunicipality = this.netAddressMunicipality
            this.addressStreet = this.netAddressStreet
            this.addressNumber = this.netAddressNumber
            this.addressPostalCode = this.netAddressPostalCode
            this.cups = this.energyCups
        },

        ...mapMutations( 'form', [
            'setField',
            'setValid',
            'setError',
            'clearErrors'
        ]),
    },

    computed: {

        ...mapState('steps', {
            showStepErrors: state => state.two.showErrors,
        }),

        ...mapState('form', {
            valid: state => state.valid,
            errors: state => state.errors,
        }),

        ...mapState('products', {
            currentConfig: state => state.currentConfig,
        }),

        ...mapGetters('form', {
            formIsValid: 'formIsValid'
        }),


        // NET
        productNetIsSelected() {
            if(this.currentConfig?.NET?.visible > 0) {
                return true;
            }
            else if(this.currentConfig?.ENERGY?.visible > 0) {
                return true;
            }
            else {
                return false;
            }
        },

        //ENERGY
        productEnergySelected() {
            return this.currentConfig?.ENERGY?.visible > 0 ?? false
        },
        productNetSelected() {
            return this.currentConfig?.NET?.visible > 0 ?? false;
        },

        netAddressProvince(){
            if(!this.productNetIsSelected) return 'barcelona'

            if(this.productNetSelected) {
                return this.currentConfig?.NET?.slots?.NET1?.config?.province_name?.toLowerCase() ?? 'barcelona'
            } else if(this.productEnergySelected) {
                return this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.province_name?.toLowerCase() ?? 'barcelona'
            } else {
                return null;
            }
        },
        netAddressMunicipality(){
            if(!this.productNetIsSelected) return null

            if(this.productNetSelected) {
                return this.currentConfig?.NET?.slots?.NET1?.config?.municipality_name ?? null
            } else if(this.productEnergySelected) {
                return this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.municipality_name ?? null
            } else {
                return null;
            }
        },
        netAddressStreet(){
            if(!this.productNetIsSelected) return null

            if(this.productNetSelected) {
                return this.currentConfig?.NET?.slots?.NET1?.config?.street_name ?? null
            } else if(this.productEnergySelected) {
                return this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.street_name ?? null
            } else {
                return null;
            }
        },
        netAddressNumber(){
            if(!this.productNetIsSelected) return null

            if(this.productNetSelected) {
                return this.currentConfig?.NET?.slots?.NET1?.config?.number_name ?? null
            } else if(this.productEnergySelected) {
                return this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.number_name ?? null
            } else {
                return null;
            }
        },
        netAddressPostalCode(){
            if(!this.productNetIsSelected) return null

            if(this.productNetSelected) {
                let codes = this.currentConfig?.NET?.slots?.NET1?.config?.postal_codes ?? []
                return codes[0] ?? null
            } else if(this.productEnergySelected) {
                let codes = this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.postal_codes ?? []
                return codes[0] ?? null
            } else {
                return null;
            }
        },

        energyCups() {
            return this.currentConfig?.ENERGY?.slots?.ENERGY1?.config?.cups ?? 0
        },
        // fields

        userType: {
            get() { return this.$store.state.form.fields.userType },
            set(value) { this.$store.commit('form/setField', {name: 'userType', value}) }
        },
        fiscalDoc: {
            get() { return this.$store.state.form.fields.fiscalDoc },
            set(value) { this.$store.commit('form/setField', {name: 'fiscalDoc', value}) }
        },
        fiscalId: {
            get() { return this.$store.state.form.fields.fiscalId },
            set(value) { this.$store.commit('form/setField', {name: 'fiscalId', value}) }
        },
        companyName: {
            get() { return this.$store.state.form.fields.companyName },
            set(value) { this.$store.commit('form/setField', {name: 'companyName', value}) }
        },
        name: {
            get() { return this.$store.state.form.fields.name },
            set(value) { this.$store.commit('form/setField', {name: 'name', value}) }
        },
        surname1: {
            get() { return this.$store.state.form.fields.surname1 },
            set(value) { this.$store.commit('form/setField', {name: 'surname1', value}) }
        },
        surname2: {
            get() { return this.$store.state.form.fields.surname2 },
            set(value) { this.$store.commit('form/setField', {name: 'surname2', value}) }
        },
        email: {
            get() { return this.$store.state.form.fields.email },
            set(value) { this.$store.commit('form/setField', {name: 'email', value}) }
        },
        phone: {
            get() { return this.$store.state.form.fields.phone },
            set(value) { this.$store.commit('form/setField', {name: 'phone', value}) }
        },
        addressCountry: {
            get() { return this.$store.state.form.fields.addressCountry },
            set(value) { this.$store.commit('form/setField', {name: 'addressCountry', value}) }
        },
        addressProvince: {
            get() { return this.$store.state.form.fields.addressProvince },
            set(value) { this.$store.commit('form/setField', {name: 'addressProvince', value}) }
        },
        addressMunicipality: {
            get() { return this.$store.state.form.fields.addressMunicipality },
            set(value) { this.$store.commit('form/setField', {name: 'addressMunicipality', value}) }
        },
        addressPostalCode: {
            get() { return this.$store.state.form.fields.addressPostalCode },
            set(value) { this.$store.commit('form/setField', {name: 'addressPostalCode', value}) }
        },
        addressStreet: {
            get() { return this.$store.state.form.fields.addressStreet },
            set(value) { this.$store.commit('form/setField', {name: 'addressStreet', value}) }
        },
        addressNumber: {
            get() { return this.$store.state.form.fields.addressNumber },
            set(value) { this.$store.commit('form/setField', {name: 'addressNumber', value}) }
        },
        addressStairwell: {
            get() { return this.$store.state.form.fields.addressStairwell },
            set(value) { this.$store.commit('form/setField', {name: 'addressStairwell', value}) }
        },
        addressFloor: {
            get() { return this.$store.state.form.fields.addressFloor },
            set(value) { this.$store.commit('form/setField', {name: 'addressFloor', value}) }
        },
        addressDoor: {
            get() { return this.$store.state.form.fields.addressDoor },
            set(value) { this.$store.commit('form/setField', {name: 'addressDoor', value}) }
        },
        iban: {
            get() { return this.$store.state.form.fields.iban },
            set(value) { this.$store.commit('form/setField', {name: 'iban', value}) }
        },
        fiscalDocAttorney: {
            get() { return this.$store.state.form.fields.fiscalDocAttorney },
            set(value) { this.$store.commit('form/setField', {name: 'fiscalDocAttorney', value}) }
        },
        fiscalIdAttorney: {
            get() { return this.$store.state.form.fields.fiscalIdAttorney },
            set(value) { this.$store.commit('form/setField', {name: 'fiscalIdAttorney', value}) }
        },
        collaborator_code: {
            get() { return this.$store.state.form.fields.collaborator_code },
            set(value) { this.$store.commit('form/setField', {name: 'collaborator_code', value}) }
        },
        order_comments: {
            get() { return this.$store.state.form.fields.order_comments },
            set(value) { this.$store.commit('form/setField', {name: 'order_comments', value}) }
        },
        terms: {
            get() { return this.$store.state.form.fields.terms },
            set(value) { this.$store.commit('form/setField', {name: 'terms', value}) }
        },

        recaptcha: {
            get() { return this.$store.state.form.fields.recaptcha },
            set(value) { this.$store.commit('form/setField', {name: 'recaptcha', value}) }
        },

        comments_length(){
            if(!this.order_comments) return 200
            return 200 - this.order_comments.length ?? 200
        }
    }
}
